<template>
    
    <div aria-label="Page navigation" v-if="links">
        <ul class="pagination">
            <li class="page-item" :class="{active: link.active, disabled: link.url === null}" v-for="(link, key) in links">
                <span v-if="link.url === null" :key="key" class="page-link" v-html="link.label" />
                <inertia-link v-else :key="key" class="page-link" :href="link.url" v-html="link.label" />
            </li>
        </ul>
    </div>
    
</template>

<script>
    export default {
        props: [
            'links'
        ],
    }
</script>